module.exports = __webpack_public_path__ + "img/zone.fc0e1e68.png";